import api from '@/api';

export const redirectToSsoLoginPage = (eventId : string , organizationId : string, dispatch : Function) => {

    // Get the WorkOS connection and domain for this Event ID
    api.account
      .getWorkOSConnection(eventId, organizationId)
      .then(response => {
        // Call the ssoLogin domain which will redirect to the WorkOS SSO signin page
        dispatch({
          type: 'account/ssoLogin',
          payload: {
            ssoConnectionId: response.data.connection_id,
            // NOTE- we are passing eventID to the backend and ref is not needed on the backend controller.
            // redirectRef: refOverride || ref,
            redirectRef: location.pathname,
            eventId: eventId,
          },
        });
      })
      .catch(() => {
        // Show a warning at the login page that SSO Login failed
        //setLoading(false);
        dispatch({
          type: 'global/addDangerToast',
          payload: { description: 'SSO for this domain is not enabled' },
        });
      });
  };
